import ModuleWrapper from 'shared-lib/containers/Module';

const BlacklistControl = () => import(/* webpackChunkName: "blacklist-control" */ '@/views/blacklistControl/BlacklistControl');
const BlacklistControlDetails = () => import(/* webpackChunkName: "blacklist-details" */ '@/views/blacklistControl/BlacklistControlDetails');

const meta = (data = {}) => ({
    privilegeModule: 'traffic_filtering', // TODO: change to blacklist_control?
    permission: 'read',
    auth: true,
    ...data,
});

export default [{
    path: 'blacklist-control',
    component: ModuleWrapper,
    meta: meta({
        title: 'BlacklistControl',
    }),
    children: [
        {
            path: '',
            name: 'BlacklistControl',
            component: BlacklistControl,
            meta: meta(),
        },
        {
            path: 'publisher/:id(\\d+)',
            name: 'BlacklistControlPublisherDetails',
            component: BlacklistControlDetails,
            props: (route) => ({
                id: route.params.id,
                type: 'publisher',
                onlyCreatedByOptimizations: !!route.params.only_created_by_optimizations,
            }),
            meta: meta(),
        },
        {
            path: 'tracking-link/:id(\\d+)',
            name: 'BlacklistControlTspDetails',
            component: BlacklistControlDetails,
            props: (route) => ({
                id: route.params.id,
                type: 'tsp',
                onlyCreatedByOptimizations: !!route.params.only_created_by_optimizations,
            }),
            meta: meta(),
        },
    ],
}];
